module.exports = __webpack_public_path__ + "static/media/PICTOS_IRIS_COMMUNAUTE.3cf01c51.png";